
<div class="row">
    <div class="p-0" [ngClass]="exam.psychometricTest ? 'col-md-12' : 'col-md-6'">
        <app-grid [columns]="columns" [rows]="data.tableRows" [tableParams]="data.tableParams" [multiSelect]="false"
            (refreshDataFromServer)="refreshData($event)" (rowSelected)="emitQuestionBankData($event)" #gridComponent
            [gridName]="gridName" (addClicked)="addQuestionBank()" [allowEdit]="!exam.psychometricTest" [allowAdd]="!exam.psychometricTest">
        </app-grid>
    </div>
    <div class="col-md-6 p-0" *ngIf="!exam.psychometricTest">
        <app-edit-examination-question-bank class="question-bank-container" 
            [selectedQuestionBank]="selectedQuestionBank"
            [exam]="exam">
        </app-edit-examination-question-bank>
    </div>
</div>